import { buildSkillStep } from "@/core/skillForms/builder";

export const feeAgreementSkillStep1 = buildSkillStep({
  title: "Detalhes",
  description:
    "Insira o detalhamento dos serviços a serem prestados e informações importantes para o contrato, como valores de honorários, forma de pagamento, multas, datas de vigência, etc.",
  fields: [
    {
      name: "case_breakdown",
      type: "string",
      ui: {
        label: "Faça um detalhamento dos serviços:",
        placeholder:
          "Exemplo: Contratação de serviços advocatícios para atuar em processo de divórcio judicial entre a Silvana e seu marido. Os honorários cobrados serão de R$ 10.000 reais somado com 10% do patrimônio total a ser partilhado no divórcio.",
        widget: "textarea",
      },
    },
  ],
});
